<div class="blog-list-container">
    <app-blog-card class="blog-card" *ngFor="let blog of blogs" [blog]="blog" (click)="onClickBlog(blog)"></app-blog-card>
</div>
